module.exports = __webpack_public_path__ + "img/DE00771.5825c784.png";